module.exports = __webpack_public_path__ + "../resources/img/ic_re_rain_thunder_solid.f53b64a8.svg";